<template>
  <div class="mobile-detail" >
    <el-card>
      <div slot="header">
        <span>操作</span>
      </div>
      <div class="main-wrap" >
        <div class="detail-area">
          <p v-for="(item, index) in oneAll"  :key="index">{{item.status}}<span class="" :class="[item.remark ? 'red' : '']">{{item.remark}}</span>名单有<span class="num">{{item.number}}</span>个</p>
          <div class="progress-wrap">
            <div class="txt"> 当前进度：</div>
            <div class="progress">
              <el-progress :percentage="progressInt"></el-progress></div>
            </div>
        </div>

        <div class="status" v-if="progressStasus == '开始拨打' && progressStasusAnd ">
          <el-button size="small" type="primary" @click="getOneDetail">开始拨打</el-button>
        </div>

        <div class="status" v-if="progressStasus == '继续拨打' && progressStasusAnd">
          <el-button size="small" type="primary"  @click="goOn">继续拨打</el-button>
        </div>

        <div v-show="showInfo">
          <div class="p2th">
            <el-select
              class="selectNext"
              popper-class="selectPop"
              v-model="reason"
              placeholder="请选择"
              clearable
              filterable
              @change="changeSelect()"
            >
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input  v-if="reason == '其他'" @input="changeInput"  class="input-style" v-model="other" placeholder="请输入内容" size="small" type="primary" ></el-input>
            <el-button size="small" type="primary" :disabled="disabled" @click="goNext" :loading="loading">标记当前号码然后下一个</el-button>
          </div>
          <div class="p1th">
            <div class="item-wrap">
              <div class="item" v-for="(item, index) in oneDetail"  :key="index">
                <div class="lbox">{{item.key}}</div>
                <div class="rbox">{{item.value}}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </el-card>
  </div>
</template>

<script>
import http from '@/plugins/axios'
export default {
  data() {
    return {
      showInfo: false,
      loading: false,
      disabled: true,
      oneAll: [],
      oneDetail: [],
      fileid: '',
      detailid: '',
      progressStasus: '',
      progressStasusAnd: true,
      not_call: 0,
      total: 0,
      userList: [
        {
          value: '关机',
          label: '关机'
        },
        {
          value: '无法接通',
          label: '无法接通'
        },
        {
          value: '无人接听',
          label: '无人接听'
        },
        {
          value: '占线',
          label: '占线'
        },
        {
          value: '开场挂机',
          label: '开场挂机'
        },
        {
          value: '不需要',
          label: '不需要'
        },
        {
          value: '无领取',
          label: '无领取'
        },
        {
          value: '有印象领取',
          label: '有印象领取'
        },
        {
          value: '为了权益领取',
          label: '为了权益领取'
        },
        {
          value: '其他',
          label: '其他'
        }
      ],
      other: '',
      reason: ''
    }
  },
  created () {
  },
  computed: {
    progressInt () {
      let per = (this.total - this.not_call) / this.total * 100
      return parseInt(per) || 0
    }
  },

  mounted() {
    this.fileid = this.$route.params.id
    this.getOneAll()
  },
  methods: {
    changeSelect() {
      if (this.reason === '其他') {
        this.disabled = true
      } else {
        this.disabled = !this.reason
      }
    },
    changeInput() {
      this.disabled = !this.other
    },

    getOneAll() {
      return new Promise((resolve) => {
        http.post('/once/jview', { fileid: this.fileid }).then((res) => {
          this.oneAll = res.data.data
          this.total = res.data.total
          this.not_call = res.data.not_call
          if (this.not_call === this.total) {
            this.progressStasus = '开始拨打'
          } else if (this.not_call > 0 && this.not_call < this.total) {
            this.progressStasus = '继续拨打'
          } else if (this.not_call === 0) {
            this.progressStasus = '拨打完成'
            this.showInfo = false
          }
          resolve(res.data)
        })
      })
    },

    getOneDetail() {
      this.progressStasusAnd = false
      this.loading = true
      this.getOneAll().then(ret => {
        http.post('/once/jview2', { fileid: this.fileid }).then((res) => {
          if (res.data.data && res.data.data['message']) {
            this.oneDetail = res.data.data['message']
            this.detailid = res.data.data['detailid']
            this.showInfo = true
            this.loading = false
          }
        })
      })
      // http.post('/once/jview2', { fileid: this.fileid }).then((res) => {
      //   this.oneDetail = res.data.data['message']
      //   this.detailid = res.data.data['detailid']
      //   this.showInfo = true
      // })
    },

    goOn() {
      this.progressStasus = ''
      this.progressStasusAnd = false
      this.getOneDetail()
    },

    goNext() {
      let remark = this.reason
      if (remark === '其他') {
        remark = this.other
      }
      this.loading = true
      http.post('/once/jmark', {
        fileid: this.fileid,
        detailid: this.detailid,
        remark: remark
      }).then((res) => {
        this.loading = false
        this.getOneDetail()
      })
    }
  }
}
</script>

<style lang="scss">
.selectPop{
    .el-select-dropdown__wrap{
    max-height: 474px;
  }
}

.mobile-detail {

  padding-bottom: 50px;
  .red{
    color: red;
     margin: 0 5px;

  }
  .main-wrap {
    font-size: 14px;
    line-height: 2.2;
    .input-style{
      width: 180px;
      margin-right: 15px;
    }
    .p1th {
      margin-bottom: 15px;
      font-size: 16px;
      .item-wrap{
        border-top: 1px solid #ebeef5;
        border-left: 1px solid #ebeef5;
        margin: 30px 20px 0 0;
        .item{
          display: flex;
          &:hover{
            background-color: #f5f7fa;
          }
          .lbox{
            width: 200px;
            border-right: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
            padding-left: 20px;
          }
          .rbox{
            flex: 1;
            padding-left: 20px;
            width: 200px;
            border-right: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
          }
        }
      }
    }
    .p2th {
      padding-top: 5px;
      margin-bottom: 20px;
      .selectNext{
        margin-right: 15px;
        width: 180px;
      }
    }
    .detail-area {
      margin-bottom: 20px;
      .progress-wrap{
        padding-top: 15px;
        display: flex;
        .progress{
          padding: 6px 0 0 10px;
          flex: 1;
        }
      }
      .num{
        color:red;
        font-weight: bold;
        font-size: 14px;
        margin: 0 3px;
      }
    }
  }
}
</style>
